import React from "react";
import stylesForOferta from "./stylesForOferta.module.css";
import Logo from "./icons/logo";
import SEO from "../components/seo";

const Oferta = () => {
  return (
    <>
      <SEO title="Политика защиты и обработки персональных данных" />
      <div className={stylesForOferta.container}>
        <div className={stylesForOferta.logo}>
          <Logo />
        </div>
        <p className={stylesForOferta.title}>
          ПОЛИТИКА ЗАЩИТЫ И ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ООО «МОСКОУ КОДИНГ
          СКУЛ» (ИНН 7725262648, ОГРН 1157746115438)
        </p>{" "}
        <p>1. Общие положения</p>{" "}
        <p>
          1.1. Настоящая Политика ООО «МОСКОУ КОДИНГ СКУЛ» (ИНН 7725262648, ОГРН
          1157746115438) в отношении обработки персональных данных (далее -
          Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1
          Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
          (далее – Закон о персональных данных) в целях обеспечения защиты прав
          и свобод человека и гражданина при обработке его персональных данных,
          в том числе защиты прав на неприкосновенность частной жизни, личную и
          семейную тайну.
        </p>{" "}
        <p>
          1.2. Политика действует в отношении всех персональных данных, которые
          обрабатывает ООО «МОСКОУ КОДИНГ СКУЛ»
        </p>{" "}
        <p>
          1.3. Политика распространяется на отношения в области обработки
          персональных данных, возникшие у Оператора как до, так и после
          утверждения настоящей Политики.
        </p>{" "}
        <p>
          1.4. Во исполнение требований ч. 2 ст. 18.1 Закона о персональных
          данных настоящая Политика публикуется в свободном доступе в
          информационно-телекоммуникационной сети Интернет на сайте Оператора.
        </p>{" "}
        <p>2. Термины и принятые сокращения</p>{" "}
        <p>
          Персональные данные – любая информация, относящаяся к прямо или
          косвенно определенному или определяемому физическому лицу (субъекту
          персональных данных).
        </p>{" "}
        <p>
          Персональные данные, разрешенные субъектом персональных данных для
          распространения – это персональные данные, доступ неограниченного
          круга лиц к которым предоставлен субъектом персональных данных путем
          дачи согласия на обработку персональных данных, разрешенных субъектом
          персональных данных для распространения.
        </p>{" "}
        <p>
          Оператор персональных данных (оператор) – государственный орган,
          муниципальный орган, юридическое или физическое лицо, самостоятельно
          или совместно с другими лицами организующие и (или) осуществляющие
          обработку персональных данных, а также определяющие цели обработки
          персональных данных, состав персональных данных, подлежащих обработке,
          действия (операции), совершаемые с персональными данными.
        </p>{" "}
        <p>
          Обработка персональных данных – любое действие (операция) или
          совокупность действий (операций) с персональными данными, совершаемых
          с использованием средств автоматизации или без их использования.
          Обработка персональных данных включает в себя в том числе:
        </p>{" "}
        <p>
          <ul>
            <li>- сбор;</li>
            <li>запись;</li>
            <li>систематизацию;</li>
            <li>накопление;</li>
            <li>хранение;</li>
            <li>уточнение (обновление, изменение);</li>
            <li>извлечение;</li>
            <li>использование;</li>
            <li>передачу (предоставление, доступ);</li>
            <li>распространение;</li> <li>обезличивание;</li>{" "}
            <li>блокирование;</li>
            <li>удаление;</li>
            <li>уничтожение</li>.
          </ul>
        </p>{" "}
        <p>
          Автоматизированная обработка персональных данных – обработка
          персональных данных с помощью средств вычислительной техники.
        </p>{" "}
        <p>
          Предоставление персональных данных – действия, направленные на
          раскрытие персональных данных определенному лицу или определенному
          кругу лиц.
        </p>{" "}
        <p>
          Блокирование персональных данных – временное прекращение обработки
          персональных данных (за исключением случаев, если обработка необходима
          для уточнения персональных данных).
        </p>
        <p>
          Уничтожение персональных данных – действия, в результате которых
          становится невозможным восстановить содержание персональных данных в
          информационной системе персональных данных и (или) в результате
          которых уничтожаются материальные носители персональных данных.
        </p>
        <p>
          Обезличивание персональных данных – действия, в результате которых
          становится невозможным без использования дополнительной информации
          определить принадлежность персональных данных конкретному субъекту
          персональных данных.
        </p>
        <p>
          Информационная система персональных данных – совокупность содержащихся
          в базах данных персональных данных и обеспечивающих их обработку,
          информационных технологий и технических средств.
        </p>
        <p>
          Трансграничная передача персональных данных – передача персональных
          данных на территорию иностранного государства органу власти
          иностранного государства, иностранному физическому лицу или
          иностранному юридическому лицу.
        </p>
        <p>3. Порядок и условия обработки и хранение персональных данных</p>
        <p>
          3.1. Обработка персональных данных осуществляется Оператором в
          соответствии с требованиями законодательства Российской Федерации.
        </p>
        <p>
          3.2. Обработка персональных данных осуществляется с согласия субъектов
          персональных данных на обработку их персональных данных, а также без
          такового в случаях, предусмотренных законодательством Российской
          Федерации.
        </p>
        <p>
          3.3. Согласие на обработку персональных данных, разрешенных субъектом
          персональных данных для распространения, оформляется отдельно от иных
          согласий субъекта персональных данных на обработку его персональных
          данных.
        </p>
        <p>
          3.4. Согласие на обработку персональных данных, разрешенных субъектом
          персональных данных для распространения, может быть предоставлено
          оператору:
        </p>
        <ul>
          <li>непосредственно;</li>
          <li>
            с использованием информационной системы уполномоченного органа по
            защите прав субъектов персональных данных.
          </li>
        </ul>
        <p>
          3.5. Оператор осуществляет как автоматизированную, так и не
          автоматизированную обработку персональных данных.
        </p>
        <p>
          3.6. К обработке персональных данных допускаются работники Оператора,
          в должностные обязанности которых входит обработка персональных
          данных.
        </p>
        <p>3.7. Обработка персональных данных осуществляется путем:</p>
        <ul>
          <li>
            получения персональных данных в устной и письменной форме
            непосредственно с согласия субъекта персональных данных на обработку
            или распространение его персональных данных;
          </li>
          <li>
            внесения персональных данных в журналы, реестры и информационные
            системы Оператора;
          </li>
          <li>использования иных способов обработки персональных данных.</li>
        </ul>
        <p>
          3.8. Не допускается раскрытие третьим лицам и распространение
          персональных данных без согласия субъекта персональных данных, если
          иное не предусмотрено федеральным законом.
        </p>
        <p>
          3.9. Передача персональных данных органам дознания и следствия, в
          Федеральную налоговую службу, Пенсионный фонд, Фонд социального
          страхования и другие уполномоченные органы исполнительной власти и
          организации осуществляется в соответствии с требованиями
          законодательства Российской Федерации.
        </p>
        <p>
          3.10. Оператор принимает необходимые правовые, организационные и
          технические меры для защиты персональных данных от неправомерного или
          случайного доступа к ним, уничтожения, изменения, блокирования,
          распространения и других несанкционированных действий, в том числе:
        </p>
        <p>
          <ul>
            <li>
              определяет угрозы безопасности персональных данных при их
              обработке;
            </li>
            <li>
              принимает локальные нормативные акты и иные документы,
              регулирующие отношения в сфере обработки и защиты персональных
              данных;
            </li>
            <li>
              назначает лиц, ответственных за обеспечение безопасности
              персональных данных в структурных подразделениях и информационных
              системах Оператора;
            </li>
            <li>
              создает необходимые условия для работы с персональными данными;
            </li>
            <li>организует учет документов, содержащих персональные данные;</li>
            <li>
              организует работу с информационными системами, в которых
              обрабатываются персональные данные;
            </li>
            <li>
              хранит персональные данные в условиях, при которых обеспечивается
              их сохранность и исключается неправомерный доступ к ним;
            </li>
            <li>
              организует обучение работников Оператора, осуществляющих обработку
              персональных данных.
            </li>
          </ul>
        </p>
        <p>
          3.11. Оператор осуществляет хранение персональных данных в форме,
          позволяющей определить субъекта персональных данных, не дольше, чем
          этого требуют цели обработки персональных данных, если срок хранения
          персональных данных не установлен федеральным законом, договором или
          соглашением.
        </p>
        <p>
          3.12. При сборе персональных данных, в том числе посредством
          информационно телекоммуникационной сети интернет, Оператор
          обеспечивает запись, систематизацию, накопление, хранение, уточнение
          (обновление, изменение), извлечение персональных данных граждан
          Российской Федерации с использованием баз данных, находящихся на
          территории Российской Федерации, за исключением случаев, указанных в
          Законе о персональных данных.
        </p>
        <p>3.13. Виды данных и цели обработки персональных данных:</p>
        <p>3.13.1. Виды ПД, которые обрабатывает Оператор:</p>
        <p>
          <ul>
            <li>ФИО</li>
            <li>Номер телефона</li>
            <li>Пол</li>
            <li>Возраст</li>
            <li>Электронная почта</li>
            <li>Юзернейм (ник) в Instagram</li>
            <li>Юзернейм (ник) в Discord</li>
            <li>Юзернейм (ник) в Telegram</li>
          </ul>
        </p>
        <p>
          3.13.2. Обработке подлежат только персональные данные, которые
          отвечают целям их обработки. Обработка Оператором персональных данных
          осуществляется в следующих целях:
        </p>
        <p>
          <ul>
            <li>
              обеспечение соблюдения Конституции, федеральных законов и иных
              нормативных правовых актов Российской Федерации;
            </li>
            <li>осуществление своей деятельности;</li>
            <li>ведение кадрового делопроизводства;</li>
            <li>
              содействие работникам в трудоустройстве, получении образования и
              продвижении по службе, обеспечение личной безопасности работников,
              контроль количества и качества выполняемой работы, обеспечение
              сохранности имущества;
            </li>
            <li>привлечение и отбор кандидатов на работу у Оператора;</li>
            <li>
              организация постановки на индивидуальный (персонифицированный)
              учет работников в системе обязательного пенсионного страхования;
            </li>
            <li>
              заполнение и передача в органы исполнительной власти и иные
              уполномоченные организации требуемых форм отчетности;
            </li>
            <li>осуществление гражданско-правовых отношений;</li>
            <li>ведение бухгалтерского учета;</li>
            <li>предоставление доступа к обучающей платформе,</li>
            <li>
              уведомление субъекта ПД об изменениях, дополнениях к оказываемым
              по договору с ним услугам,
            </li>
            <li>
              предоставление доступа к бесплатным материалам (в том числе
              проводимым тренингам/курсам/буткемпам),
            </li>
            <li>
              рассылка информации, в том числе рекламного характера, об акциях,
              событиях и специальных предложениях,
            </li>
            <li>
              получение обратной связи, отзывов и рекомендаций от Субъекта,
            </li>
            <li>
              проведение опросов для эффективной коммуникации с действующими и
              потенциальными клиентами Оператора.
            </li>
          </ul>
        </p>
        <p>
          3.14.3. Обработка персональных данных работников может осуществляться
          исключительно в целях обеспечения соблюдения законов и иных
          нормативных правовых актов.
        </p>
        <p>3.15. Категории субъектов персональных данных.</p>
        <p>Обрабатываются ПД следующих субъектов ПД:</p>
        <p>
          <ul>
            <li>
              физические лица, состоящие с Оператором в трудовых отношениях;
            </li>
            <li>физические лица, уволившиеся от Оператора;</li>
            <li>физические лица, являющиеся кандидатами на работу;</li>
            <li>
              физические лица, состоящие с Оператором в гражданско-правовых
              отношениях.
            </li>
          </ul>
        </p>
        <p>3.16. ПД, обрабатываемые Оператором:</p>
        <p>
          <ul>
            <li>данные, полученные при осуществлении трудовых отношений;</li>
            <li>
              данные, полученные для осуществления отбора кандидатов на работу;
            </li>
            <li>
              данные, полученные при осуществлении гражданско-правовых
              отношений.
            </li>
          </ul>
        </p>
        <p>3.17. Хранение ПД.</p>
        <p>
          3.17.1. ПД субъектов могут быть получены, проходить дальнейшую
          обработку и передаваться на хранение как на бумажных носителях, так и
          в электронном виде.
        </p>
        <p>
          3.17.2. ПД, зафиксированные на бумажных носителях, хранятся в
          запираемых шкафах либо в запираемых помещениях с ограниченным правом
          доступа.
        </p>
        <p>
          3.17.3. ПД субъектов, обрабатываемые с использованием средств
          автоматизации в разных целях, хранятся в разных папках.
        </p>
        <p>
          3.17.4. Не допускается хранение и размещение документов, содержащих
          ПД, в открытых электронных каталогах (файлообменниках) в ИСПДн.
        </p>
        <p>
          3.17.5. Хранение ПД в форме, позволяющей определить субъекта ПД,
          осуществляется не дольше, чем этого требуют цели их обработки, и они
          подлежат уничтожению по достижении целей обработки или в случае утраты
          необходимости в их достижении.
        </p>
        <p>3.17. Уничтожение ПД.</p>
        <p>
          3.17.1. Уничтожение документов (носителей), содержащих ПД,
          производится путем сожжения, дробления (измельчения), химического
          разложения, превращения в бесформенную массу или порошок. Для
          уничтожения бумажных документов допускается применение шредера.
        </p>
        <p>
          3.17.2. ПД на электронных носителях уничтожаются путем стирания или
          форматирования носителя.
        </p>
        <p>
          3.17.3. Факт уничтожения ПД подтверждается документально актом об
          уничтожении носителей.
        </p>
        <p>4. Защита персональных данных</p>
        <p>
          4.1. В соответствии с требованиями нормативных документов Оператором
          создана система защиты персональных данных (СЗПД), состоящая из
          подсистем правовой, организационной и технической защиты.
        </p>
        <p>
          4.2. Подсистема правовой защиты представляет собой комплекс правовых,
          организационно- распорядительных и нормативных документов,
          обеспечивающих создание, функционирование и совершенствование СЗПД.
        </p>
        <p>
          4.3. Подсистема организационной защиты включает в себя организацию
          структуры управления СЗПД, разрешительной системы, защиты информации
          при работе с сотрудниками, партнерами и сторонними лицами.
        </p>
        <p>
          4.4. Подсистема технической защиты включает в себя комплекс
          технических, программных, программно-аппаратных средств,
          обеспечивающих защиту ПД.
        </p>
        <p>
          4.4. Основными мерами защиты ПД, используемыми Оператором, являются:
        </p>
        <p>
          4.5.1. Назначение лица, ответственного за обработку ПД, которое
          осуществляет организацию обработки ПД, обучение и инструктаж,
          внутренний контроль за соблюдением учреждением и его работниками
          требований к защите ПД.
        </p>
        <p>
          4.5.2. Определение актуальных угроз безопасности ПД при их обработке в
          ИСПД и разработка мер и мероприятий по защите ПД.
        </p>
        <p>
          4.5.3. Разработка политики в отношении обработки персональных данных.
        </p>
        <p>
          4.5.4. Установление правил доступа к ПД, обрабатываемым в ИСПД, а
          также обеспечение регистрации и учета всех действий, совершаемых с ПД
          в ИСПД.
        </p>
        <p>
          4.5.5. Установление индивидуальных паролей доступа сотрудников в
          информационную систему в соответствии с их производственными
          обязанностями.
        </p>
        <p>
          4.5.6. Применение прошедших в установленном порядке процедуру оценки
          соответствия средств защиты информации.
        </p>
        <p>
          4.5.7. Сертифицированное антивирусное программное обеспечение с
          регулярно обновляемыми базами.
        </p>
        <p>
          4.5.8. Соблюдение условий, обеспечивающих сохранность ПД и исключающих
          несанкционированный к ним доступ.
        </p>
        <p>
          4.5.9. Обнаружение фактов несанкционированного доступа к персональным
          данным и принятие мер.
        </p>
        <p>
          4.5.10. Восстановление ПД, модифицированных или уничтоженных
          вследствие несанкционированного доступа к ним.
        </p>
        <p>
          4.5.11. Обучение работников Оператора, непосредственно осуществляющих
          обработку персональных данных, положениям законодательства РФ о
          персональных данных, в том числе требованиям к защите персональных
          данных, документам, определяющим политику Оператора в отношении
          обработки персональных данных, локальным актам по вопросам обработки
          персональных данных.
        </p>
        <p>4.5.12. Осуществление внутреннего контроля и аудита.</p>
        <p>5. Основные права субъекта ПД и обязанности Оператора</p>
        <p>5.1. Основные права субъекта ПД.</p>
        <p>
          Субъект имеет право на доступ к его персональным данным и следующим
          сведениям:
        </p>
        <p>
          <ul>
            <li>подтверждение факта обработки ПД Оператором;</li>
            <li>правовые основания и цели обработки ПД;</li>
            <li>цели и применяемые Оператором способы обработки ПД;</li>
            <li>
              наименование и место нахождения Оператора, сведения о лицах (за
              исключением работников Оператора), которые имеют доступ к ПД или
              которым могут быть раскрыты ПД на основании договора с Оператором
              или на основании федерального закона;
            </li>
            <li>
              сроки обработки персональных данных, в том числе сроки их
              хранения;
            </li>
            <li>
              порядок осуществления субъектом ПД прав, предусмотренных настоящим
              Федеральным законом;
            </li>
            <li>
              наименование или фамилия, имя, отчество и адрес лица,
              осуществляющего обработку ПД по поручению Оператора, если
              обработка поручена или будет поручена такому лицу;
            </li>
            <li>обращение к Оператору и направление ему запросов;</li>
            <li>обжалование действий или бездействия Оператора.</li>
          </ul>
        </p>
        <p>5.2. Обязанности Оператора.</p>
        <p>Оператор обязан:</p>
        <p>
          <ul>
            <li>при сборе ПД предоставить информацию об обработке ПД;</li>
            <li>
              в случаях если ПД были получены не от субъекта ПД, уведомить
              субъекта;
            </li>
            <li>
              при отказе в предоставлении ПД субъекту разъясняются последствия
              такого отказа;
            </li>
            <li>
              опубликовать или иным образом обеспечить неограниченный доступ к
              документу, определяющему его политику в отношении обработки ПД, к
              сведениям о реализуемых требованиях к защите ПД;
            </li>
            <li>
              принимать необходимые правовые, организационные и технические меры
              или обеспечивать их принятие для защиты ПД от неправомерного или
              случайного доступа к ним, уничтожения, изменения, блокирования,
              копирования, предоставления, распространения ПД, а также от иных
              неправомерных действий в отношении ПД;
            </li>
            <li>
              давать ответы на запросы и обращения субъектов ПД, их
              представителей и уполномоченного органа по защите прав субъектов
              ПД.
            </li>
          </ul>
        </p>
        <p>
          6. Актуализация, исправление, удаление и уничтожение персональных
          данных, ответы на запросы субъектов на доступ к персональным данным
        </p>
        <p>
          6. Актуализация, исправление, удаление и уничтожение персональных
          данных, ответы на запросы субъектов на доступ к персональным данным
        </p>
        <p>
          6.1. Подтверждение факта обработки персональных данных Оператором,
          правовые основания и цели обработки персональных данных, а также иные
          сведения, указанные в ч. 7 ст. 14 Закона о персональных данных,
          предоставляются Оператором субъекту персональных данных или его
          представителю при обращении либо при получении запроса субъекта
          персональных данных или его представителя.
        </p>
        <p>
          В предоставляемые сведения не включаются персональные данные,
          относящиеся к другим субъектам персональных данных, за исключением
          случаев, когда имеются законные основания для раскрытия таких
          персональных данных.
        </p>
        <p>Запрос должен содержать:</p>
        <p>
          <ul>
            <li>
              номер основного документа, удостоверяющего личность субъекта
              персональных данных или его представителя, сведения о дате выдачи
              указанного документа и выдавшем его органе;
            </li>
            <li>
              сведения, подтверждающие участие субъекта персональных данных в
              отношениях с Оператором (номер договора, дата заключения договора,
              условное словесное обозначение и (или) иные сведения), либо
              сведения, иным образом подтверждающие факт обработки персональных
              данных Оператором;
            </li>
            <li>подпись субъекта персональных данных или его представителя.</li>
          </ul>
        </p>
        <p>
          Запрос может быть направлен в форме электронного документа и подписан
          электронной подписью в соответствии с законодательством Российской
          Федерации.
        </p>
        <p>
          Если в обращении (запросе) субъекта персональных данных не отражены в
          соответствии с требованиями Закона о персональных данных все
          необходимые сведения или субъект не обладает правами доступа к
          запрашиваемой информации, то ему направляется мотивированный отказ.
        </p>
        <p>
          Право субъекта персональных данных на доступ к его персональным данным
          может быть ограничено в соответствии с ч. 8 ст. 14 Закона о
          персональных данных, в том числе если доступ субъекта персональных
          данных к его персональным данным нарушает права и законные интересы
          третьих лиц.
        </p>
        <p>
          6.2. В случае выявления неточных персональных данных при обращении
          субъекта персональных данных или его представителя либо по их запросу
          или по запросу Роскомнадзора Оператор осуществляет блокирование
          персональных данных, относящихся к этому субъекту персональных данных,
          с момента такого обращения или получения указанного запроса на период
          проверки, если блокирование персональных данных не нарушает права и
          законные интересы субъекта персональных данных или третьих лиц.
        </p>
        <p>
          В случае подтверждения факта неточности персональных данных Оператор
          на основании сведений, представленных субъектом персональных данных
          или его представителем либо Роскомнадзором, или иных необходимых
          документов уточняет персональные данные в течение семи рабочих дней со
          дня представления таких сведений и снимает блокирование персональных
          данных.
        </p>
        <p>
          6.3. В случае выявления неправомерной обработки персональных данных
          при обращении (запросе) субъекта персональных данных или его
          представителя либо Роскомнадзора Оператор осуществляет блокирование
          неправомерно обрабатываемых персональных данных, относящихся к этому
          субъекту персональных данных, с момента такого обращения или получения
          запроса.
        </p>
        <p>
          6.4. При достижении целей обработки персональных данных, а также в
          случае отзыва субъектом персональных данных согласия на их обработку
          персональные данные подлежат уничтожению, если:
        </p>
        <p>
          <ul>
            <li>
              иное не предусмотрено договором, стороной которого,
              выгодоприобретателем или поручителем по которому является субъект
              персональных данных;
            </li>
            <li>
              оператор не вправе осуществлять обработку без согласия субъекта
              персональных данных на основаниях, предусмотренных Законом о
              персональных данных или иными федеральными законами;
            </li>
            <li>
              иное не предусмотрено другим соглашением между Оператором и
              субъектом персональных данных.
            </li>
          </ul>
        </p>
        <p>
          6.5. Адрес эл. почты Оператора для направления заявлений и запросов от
          Субъектов ПД yo@guidedao.xyz
        </p>
      </div>
    </>
  );
};
export default Oferta;
